import { guid } from '../../../../../../alan_btn/src/helpers/mini/guid';
import { ITransform, ITransformRow } from '../../../../models/ITransform';
import { ITransformFile } from '../../../../models/ITransformFile';
import { getEmptyTransform } from './getTransformText';

export function getTransformFromTransformFile(transformFiles: ITransformFile[]) {
    return {
        header: transformFiles[0] ? transformFiles[0].header : getEmptyTransform().header,
        rows: [...transformFiles.map(file => {
            return {
                id: guid(),
                prompt: file.prompt,
                query: file.query,
                result: file.result,
                input: file.input,
                visible: true
            } as ITransformRow;
        })]
    } as ITransform;
}